import { Texts } from '../../types';
import { baseApiClient } from '../clients';

const CASE_OVERVIEW_TEXTS_URL = '/texts/caseOverview';
const CONTACT_FORM_TEXTS_URL = '/texts/caseDetails';
const TEAM_SHARE_TEXTS_URL = '/ContactForm';
const GLOBAL_OVERVIEW_TEXTS_URL = '/globalContent';

type CaseOverviewResponse = {
  caseOverviewTexts: Texts['caseOverviewTexts'];
};
type CaseDetailsResponse = {
  caseDetailsTexts: Texts['caseDetailsTexts'];
};
type TeamShareResponse = Texts['teamShareTexts'];
type GlobalContentResponse = {
  globalContent: Texts['globalContentTexts'];
};

const getCaseOverviewTexts = (lang: string = 'da') => {
  return baseApiClient.get<CaseOverviewResponse>(`${CASE_OVERVIEW_TEXTS_URL}?language=${lang}`);
};

const getCaseDetailsTexts = (lang: string = 'da') => {
  return baseApiClient.get<CaseDetailsResponse>(`${CONTACT_FORM_TEXTS_URL}?language=${lang}`);
};

const getTeamShareTexts = (lang: string = 'da') => {
  return baseApiClient.get<TeamShareResponse>(`${TEAM_SHARE_TEXTS_URL}?language=${lang}`);
};

const getGlobalContentTexts = (lang: string = 'da') => {
  return baseApiClient.get<GlobalContentResponse>(`${GLOBAL_OVERVIEW_TEXTS_URL}?language=${lang}`);
};

const getTexts = async (lang: string = 'da') => {
  const response = await Promise.all([
    getGlobalContentTexts(lang),
    getCaseOverviewTexts(lang),
    getCaseDetailsTexts(lang),
    getTeamShareTexts(lang),
  ]);
  return response;
};

export default getTexts;
